/**
 * Words people type for a destination that its label does not contain, keyed
 * by destination id. Feeds the Go box matcher, so "calories" finds Food Diary
 * and "money" finds Financial. Kept apart from the catalog so its rows stay
 * one line each; a test pins every key to a catalog id.
 */
export const DESTINATION_KEYWORDS: Readonly<Record<string, readonly string[]>> = {
  home: ['dashboard', 'start'],
  chat: ['assistant', 'ask', 'talk'],
  conversations: ['past chats', 'chat history'],
  inbox: ['email', 'mail', 'gmail'],
  starred: ['process later'],
  'reading-room': ['articles', 'read later', 'longform', 'newsletters'],
  'paper-trail': ['archive', 'all mail', 'filed'],
  'bulletin-board': ['fyi', 'announcements'],
  drafts: ['unsent'],
  'dismissed-inboxes': ['cleared inboxes'],
  labels: ['folders'],
  sent: ['outbox'],
  spam: ['junk'],
  'email-settings': ['rules', 'filters', 'blocked senders'],
  notes: ['documents', 'docs', 'files'],
  journal: ['diary', 'daily', 'entries', 'log'],
  study: ['boards', 'ideas', 'cards', 'writing'],
  research: ['sources', 'collections', 'papers'],
  agenda: ['calendar', 'events', 'reminders', 'schedule', 'upcoming'],
  tasks: ['todo', 'to-do', 'to do', 'checklist', 'lists'],
  'food-diary': [
    'calories',
    'nutrition',
    'macros',
    'log food',
    'eating',
    'breakfast',
    'lunch',
    'dinner',
    'snack',
  ],
  'my-foods': ['saved foods', 'food library'],
  meals: ['meal plan', 'menu', 'recipes', 'groceries', 'grocery list', 'shopping list'],
  'meals-foods': ['ingredients', 'dishes'],
  'trip-menus': ['travel', 'camping', 'vacation'],
  'meals-settings': ['meal preferences'],
  'blocked-days': ['skip days'],
  financial: ['money', 'finances', 'net worth'],
  budget: ['spending'],
  'cash-flow': ['income', 'expenses'],
  retirement: ['401k', 'ira', 'pension'],
  'debt-savings': ['loans', 'savings', 'goals'],
  jobs: ['salary', 'paycheck'],
  transactions: ['purchases', 'charges', 'bank'],
  investments: ['stocks', 'portfolio'],
  reports: ['charts', 'statements'],
  contacts: ['people', 'address book', 'phone numbers'],
  wellness: ['health', 'weight', 'exercise', 'sleep', 'habits', 'workouts'],
  memories: ['remember', 'facts'],
  household: ['family', 'house'],
  texts: ['texts', 'sms', 'imessage'],
  settings: ['preferences', 'profile', 'account'],
};
